import FractionDsnPrenom from '@/generated/controls/fractionDsn/FractionDsnPrenom.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: FractionDsnPrenom
})

